/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Preview_LiveInputs */

const en_highlight_settings_preview_live = /** @type {(inputs: Highlight_Settings_Preview_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`live`)
};

const es_highlight_settings_preview_live = /** @type {(inputs: Highlight_Settings_Preview_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vista`)
};

/**
* | output |
* | --- |
* | "live" |
*
* @param {Highlight_Settings_Preview_LiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_preview_live = /** @type {((inputs?: Highlight_Settings_Preview_LiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Preview_LiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_preview_live(inputs)
	return en_highlight_settings_preview_live(inputs)
});